function KibanaLog(core) {
    this.client = core.client;
}

Object.assign(KibanaLog.prototype, {
    namespace: 'KibanaLog',
    send(data) {
        return this.client.send('POST', `${config.baseUrl}api/log/wizyconf`, data);
    }
});

export default KibanaLog;
